function checkVideoType(url) {
  if (url.includes('mp4')) {
    return 'video/mp4';
  }

  if (url.includes('m3u8-aapl-v3')) {
    return 'application/x-mpegURL';
  }
}

export const usePromoteVideo = (data = null, type = null) => {
  if (data.contentForTopSlider !== 'previewVideo' || !data) return null;

  switch (type) {
    case 'Video': {
      const url =
        data.previewStreamingUrl ||
        data.previewVideoUrl ||
        data.previewLocatorUrl ||
        data.trailerLocatorUrl;

      if (!url) return null;

      return {
        src: url,
        type: checkVideoType(url),
      };
    }

    case 'LiveTVVideo': {
      const url =
        data.previewStreamingUrl ||
        data.previewVideoUrl ||
        data.previewLocatorUrl ||
        data.trailerLocatorUrl;

      if (!url) return null;

      return {
        src: url,
        type: checkVideoType(url),
      };
    }

    case 'Clothes': {
      const url = data.previewAwsKey;

      if (!url) return null;

      return {
        src: url,
        type: checkVideoType(url),
      };
    }

    case 'Venues': {
      const url = data.previewAwsKey;

      if (!url) return null;

      return {
        src: url,
        type: checkVideoType(url),
      };
    }

    default:
      return null;
  }
};
